<template>
    <div class="m-trend u-pt40 u-pl32 u-pr32">
        <header f-font-PFM s-cr="#323232" class="g-fs36 f-bold">相关基金</header>
        <ul>
            <li v-for="(item, index) in relateFunds" :key="item.fundCode" @click="goSee(index, item.fundCode, item.fundType)">
                <div>
                    <span class="g-fs40 u-block" :class="{red: item.profit > 0, green: item.profit < 0}">{{item.profit | formatProfit('', true)}}</span>
                    <span class="g-fs28 u-block" s-cr="#999999" f-font-PFR>{{item.text || '--'}}</span>
                </div>
                <div>
                    <span f-font-PFM s-cr="#323232" class="g-fs32 u-block f-ellipsis u-pl10 u-pr10">{{item.fundText || '--'}}</span>
                    <span class="g-fs28 u-block f-ellipsis u-pl10 u-pr10" s-cr="#999999" f-font-PFR>{{item.fundName || '--'}}</span>
                </div>
                <div class="f-tc">
                    <span class="g-fs24" s-cr="#FFFFFF" f-font-PFR>去看看</span>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
    import { goStockPage, config } from '@/assets/js/common.js';
    export default {
        name: "trend",
        props: {
            relateFunds: {
                type: Array,
                default: () => {
                    return []
                }
            }
        },
        methods: {
            goSee(num, code, type) {
                if (config.isSharePage) return;
                num = Number(num) + 1;
                _.log().jumpPageStat(`jijin.${num}`, 'seat_null');
                if (type === 'inner') {
                    goStockPage(code, '');
                } else {
                    _.jump(`fund_mkt_20210517_index_${_.fn.getUrlParam('code')}.jijin.${num}`).fund(code);
                }
                
            }
        },
        mounted() {
            console.log(this.relateFunds);
        }
    }
</script>

<style lang="less">
.m-trend {
    padding-bottom: 16px;
    ul {
        margin-top: 24px;
        li {
            display: flex;
            justify-content: space-between;
            align-items: center;
            box-sizing: border-box;
            padding: 36px 24px 32px;
            background: #FFFFFF;
            border: 1px solid #F6F6F6;
            box-shadow: 0px 0px 24px 0px rgba(0,0,0,0.04);
            border-radius: 16px;
            margin-bottom: 24px;
            div {
                span:last-child {
                    line-height: 40px;
                }
                &:first-child {
                    span:first-child {
                        letter-spacing: 0.2px;
                        font-weight: 500;
                        line-height: 48px;
                        margin-bottom: 4px;
                    }
                }
                &:nth-child(2) {
                    width: 320px;
                    text-align: left;
                    span:first-child {
                        line-height: 44px;
                        font-weight: 500;
                        margin-bottom: 4px;
                    }
                }
                &:last-child {
                    width: 104px;
                    height: 48px;
                    background: #FF330A;
                    border-radius: 8px;
                    span {
                        line-height: 48px;
                        font-weight: 400;
                    }
                }
                .red {
                    color: #FF330A;
                }
                .green {
                    color: #00BB1D;
                }
            }
        }
    }
}
</style>